import { queryParams } from "lib/queryParams";

export function isPaymentDeepLink() {
  const hash = queryParams.hash || "";
  try {
    return decodeURIComponent(hash).includes("page=payment");
  } catch (e) {
    return hash.includes("page=payment");
  }
}
